import { Dialog, DialogProps } from "../core/components/dialog";
import { Grid } from "../core/components/grid"
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import React from "react";
import ReactDOM from "react-dom";
export const OpenServiceReportCopiedInfoDialog = (data: any) => {
    return new Promise<boolean>((resolve) => {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        const props: any = {
            onOk: () => {
                resolve(true)
            },
            onCancel: () => {
                resolve(false);
                root.unmount();
            },
            data: data
        }
        $("body").append(targetElement);
        root.render(<ServiceReportCopiedInfoDialog {...props} />);
    })
}

export class ServiceReportCopiedInfoDialog extends React.Component<any, any>{
    private _dialogProps: DialogProps = {
        title: Helper.getTranslation("WebCRM.Tasks.ExecuteAll.Result"),
        actions: [
            {
                label: Config.translations.ok,
                action: () => {
                },
                primary: true
            }
        ],
        width: 1200
    };

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (<>
            <Dialog {...this._dialogProps} open={true}>
                <ServiceReportCopiedInfoGrid data={this.props.data}></ServiceReportCopiedInfoGrid>
            </Dialog>
        </>)
    }
}

export class ServiceReportCopiedInfoGrid extends React.Component<{
    data: any;
}, any>{
    private _gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        selectable: true,
        editable: false,
        height: 600,
        columns: [
            {
                field: "Successful",
                title: Helper.getTranslation("ServiceReport.Successful"),
                width: 60,
                template: "# if(data.Successful) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
            },
            {
                field: "NewBelegNr",
                title: Helper.getTranslation("WebSMS.Report.Report.ReportNr"),
                width: 80,
                template: `# if(data.NewBelegNr != 0) {# <a href='${Config.baseUrl}ServiceReport/Edit?id=#=NewBelegNr#' target='_blank'>#= NewBelegNr #</a> #} else { '-' }#`
            },
            {
                field: "ProjNr",
                title: Helper.getTranslation("BrowserTitle.Assigment.Available"),
                width: 80,
                template: `<a href=${Config.baseUrl}ResourcePlanning/Edit?projNr=#=data.ProjNr#&pIndex=#=data.PIndex# target='_blank'>#=data.ProjNr#/#=data.PIndex#</a>`
            },
            {
                field: "RessNr",
                title: Helper.getTranslation("Field.Ressource.ressnr"),
                width: 80,
            },
            {
                field: "Name",
                title: Helper.getTranslation("BrowserTitle.Resource.Available"),
                width: 120,
                template: "#=data.Name ?? ''# #=data.Vorname ?? ''#"
            },
            {
                field: "Errors",
                title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Multiselect.ErrorMessage"),
                width: 300,
                template: `#=data.Errors?.join('</br>')#`
            },
            {
                field: "Warnings",
                title: Helper.getTranslation("ServiceReport.Warnings"),
                width: 300,
                template: `#=data.Warnings?.join('</br>')#`
            }
        ]
    };

    constructor(props) {
        super(props)
    }

    render() {
        return <>
            <Grid id="serviceReportCopiedInfoGrid" data={this.props.data} options={this._gridOptions} />
        </>
    }
}